import { AsyncSaveable } from "./async_savable";
import { ValidationError } from "../error";

// TODO: eslint fix
/* eslint-disable @typescript-eslint/no-explicit-any */
export class Validateable extends AsyncSaveable {
	public meta: any = {};

	public setValidationErrors(val_error: ValidationError): void {
		this.meta = val_error.responseErrors.reduce((error, currError) => {
			if (currError.meta === undefined || currError.meta === null) {
				return error;
			}
			const field = currError.meta.field;
			if (error.hasOwnProperty(field) && error[field] !== "") {
				if (this.hasOwnProperty(field)) {
					this.wiggle(field);
				}
				error[field].items.push(currError.meta);
				return error;
			}
			return {
				...error,
				[field]: {
					message: currError.title,
					items: [currError.meta]
				}
			};
		}, {});
	}

	public cloneError(fieldName: string, copyName: string): void {
		this.meta[copyName] = {};
		if (this.hasError(fieldName)) {
			Object.assign(this.meta[copyName], this.meta[fieldName]);
		}
	}

	public getValidationError(fieldname: string): string {
		if (this.meta.hasOwnProperty(fieldname)) {
			return this.meta[fieldname].message;
		}
		return "";
	}

	public getValidationListError(fieldname: string): {
		message: string;
		items: any[];
	} {
		if (this.meta.hasOwnProperty(fieldname)) {
			return this.meta[fieldname];
		}
		return {
			message: "",
			items: []
		};
	}

	public hasError(fieldname: string): boolean {
		return this.getValidationError(fieldname) !== "";
	}

	public setError(fieldname: string, value: string): void {
		if (!this.meta[fieldname]) {
			this.meta[fieldname] = {};
		}
		this.meta[fieldname]["message"] = value;
	}

	public clearError(): void {
		this.meta = {};
	}

	public wiggle(field: string): void {
		if (!this[field + "_wiggle"]) {
			this[field + "_wiggle"] = true;
			setTimeout(() => {
				delete this[field + "_wiggle"];
			}, 1000);
		}
	}
}
